import React from 'react';
import PropTypes from 'prop-types';

export const Divider = ({className = ''}) => (
  <div
    data-testid='atom-divider'
    className={`my-5 w-full border border-[color:var(--color-border-divider)] ${className}`}
  />
);

Divider.propTypes = {
  className: PropTypes.string
};

export default React.memo(Divider);
